
import { useIsVisible } from '@components';
import { BlueButton } from '@share/components';

import './style.scss';
import { ILoginState } from '@share/store/slices';
import { useSelector } from 'react-redux';
import { FunctionalRootState, getPreferenceFromAccount } from '@share/utils';
import { BANNER_SECONDARY_PHOTO_URL_FIELD_KEY } from '@share/common-types';

interface IProps {
  onClick: () => void;
}

export function SearchAshevillePlayCall({ onClick }: IProps) {
  const [elementRef, isVisible] = useIsVisible<HTMLDivElement>();

  const loginStore: ILoginState = useSelector((state: FunctionalRootState) => state.loginStore);
  const { account } = loginStore;

  const imageUrl = getPreferenceFromAccount(account, BANNER_SECONDARY_PHOTO_URL_FIELD_KEY);

  const backgroundImage = 'https://hutchapps.com/ashevilleplay/img/heros/adventure-bg.jpg';

  const image = imageUrl ? imageUrl : backgroundImage;

  return (
    <section ref={elementRef} className="search-asheville-play-call" style={{ backgroundImage: `url(${image})` }}>
      <div className="container clearfix">
        <div className={`col-lg-5 col-md-6 float-end wow position-relative ${isVisible ? 'animated' : ''}`} data-wow-offset="250" style={{ visibility: 'visible' }}>
          <div className="block-reveal">
            <div className="block-vertical"></div>
            <div className="box_1">
              <small className="uppercase text-brand-green-light fw-bold pb-2" style={{ fontSize: '0.9rem' }}>Make your getaway unforgettable</small>
              <h3>Book a Hotel &amp; Save <strong className="fw-bolder text-brand-yellow">20%</strong> on Asheville's #1 Attraction</h3>
              <p>Pair your hotel with the city’s most exciting tours — scenic, off-road, and unforgettable. Explore the mountains, waterfalls, and breweries that make Asheville amazing.</p>
              <BlueButton onClick={onClick}> Take me to the Deal!</BlueButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

